import { render, staticRenderFns } from "./changePassword-detail.vue?vue&type=template&id=024fd5c2&scoped=true"
import script from "./changePassword-detail.vue?vue&type=script&lang=js"
export * from "./changePassword-detail.vue?vue&type=script&lang=js"
import style0 from "./changePassword-detail.vue?vue&type=style&index=0&id=024fd5c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024fd5c2",
  null
  
)

export default component.exports